/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_SubscriptionsInputs */

const en_svchip_subscriptions = /** @type {(inputs: Svchip_SubscriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscriptions`)
};

const ar_svchip_subscriptions = /** @type {(inputs: Svchip_SubscriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الاشتراكات`)
};

const bn_svchip_subscriptions = /** @type {(inputs: Svchip_SubscriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সাবস্ক্রিপশন`)
};

const de_svchip_subscriptions = /** @type {(inputs: Svchip_SubscriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnements`)
};

const es_svchip_subscriptions = /** @type {(inputs: Svchip_SubscriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscripciones`)
};

const fr_svchip_subscriptions = /** @type {(inputs: Svchip_SubscriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnements`)
};

const pt_svchip_subscriptions = /** @type {(inputs: Svchip_SubscriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assinaturas`)
};

const zh_svchip_subscriptions = /** @type {(inputs: Svchip_SubscriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订阅`)
};

const tr_svchip_subscriptions = /** @type {(inputs: Svchip_SubscriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonelikler`)
};

const ru_svchip_subscriptions = /** @type {(inputs: Svchip_SubscriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подписки`)
};

const pl_svchip_subscriptions = /** @type {(inputs: Svchip_SubscriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subskrypcje`)
};

/**
* | output |
* | --- |
* | "Subscriptions" |
*
* @param {Svchip_SubscriptionsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_subscriptions = /** @type {((inputs?: Svchip_SubscriptionsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_SubscriptionsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_subscriptions(inputs)
	if (locale === "bn") return bn_svchip_subscriptions(inputs)
	if (locale === "de") return de_svchip_subscriptions(inputs)
	if (locale === "es") return es_svchip_subscriptions(inputs)
	if (locale === "fr") return fr_svchip_subscriptions(inputs)
	if (locale === "pt") return pt_svchip_subscriptions(inputs)
	if (locale === "zh") return zh_svchip_subscriptions(inputs)
	if (locale === "tr") return tr_svchip_subscriptions(inputs)
	if (locale === "ru") return ru_svchip_subscriptions(inputs)
	if (locale === "pl") return pl_svchip_subscriptions(inputs)
	return en_svchip_subscriptions(inputs)
});